import SelectInput from 'components/shared/SelectInput';
import React from 'react';
import { capitalize } from 'shared/lib';
import { ILanguage, IVoiceFilter } from './types';

interface LanguageSelectProps {
  languages: ILanguage[];
  filters: IVoiceFilter;
  onFilterSet: (filter: IVoiceFilter) => void;
}

const LanguageSelect = ({
  languages,
  filters,
  onFilterSet
}: LanguageSelectProps) => {
  const handleChange = (newLang: string) => {
    onFilterSet({
      ...filters,
      language: newLang
    });
  };

  const languageMap: Record<string, ILanguage> = languages.reduce((acc, l) => {
    acc[l.language] = l;
    return acc;
  }, {} as Record<string, ILanguage>);

  const options = languages.map((l) => l.language);

  return (
    <SelectInput
      name="language"
      options={options}
      value={filters.language}
      onChange={handleChange}
      placeholder="Select language"
      CustomBtn={({ value, open }) => (
        <div className="ag-flex ag-flex-row ag-gap-x-2 ag-items-center">
          {value && (
            <>
              <span className="mr-1">{languageMap[value]?.country?.emoji}</span>
              <span>{capitalize(value)}</span>
            </>
          )}
          {!value && <span>Select language</span>}
        </div>
      )}
      optionsWrapperClassName="!ag-bg-white !ag-border-neutral-200 ag-left-0 ag-h-[150px]"
      className="ag-h-10 !ag-rounded-[10px] !ag-bg-neutral-50 !ag-border-neutral-200 !ag-text-neutral-700 !ag-w-full "
      wrapperClassName="!ag-bg-white !ag-text-neutral-700 !ag-border-neutral-200 !ag-w-full"
      optionsClassName="ag-text-neutral-700 ag-border-neutral-200 ag-text-sm ag-py-1 hover:ag-bg-neutral-200/80 dark:hover:ag-bg-[#262626]/80"
    />
  );
};

export default LanguageSelect;
